import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as endpoints from './../../../../Service/endpoints';
import Modal from '../../../UI/Modal';
import Icon from '../../../UI/Icon';
import "./../../../../styles/modal-styles.css";

// Service areas currently supported by the storefront (ids match the inventory API).
const CITIES = [
    { name: 'delhi', label: 'Delhi', id: 2 },
    { name: 'gurgaon', label: 'Gurgaon', id: 1 },
];

class ServiceAreaSelect extends Component {

    selectCity = (cityName, cityId) => {

        localStorage.setItem("city", cityName);
        localStorage.setItem("cityId", cityId);
        this.props.selectCityClose();

        var path = window.location.pathname;
        var pathArray = path.split("/");
        pathArray.splice(0, 2);
        var finalPath = pathArray.join("/");
        window.location.href = endpoints.getRoute(finalPath)

    }

    closeModal = () => {
        this.props.selectCityClose();
    }

    componentDidMount() {
        if (typeof navigator !== "undefined" && /ReactSnap/i.test(navigator.userAgent || "")) {
            return;
        }

        const currentCity = endpoints.getCurrentCity();

        if (typeof localStorage.city === "undefined" || window.location.pathname === "/noida" || window.location.pathname === "/noida/") {
            this.props.selectCityOpen();
        } else {
            if (window.location.pathname === "/") {
                window.location.href = `/${currentCity}`;
            }
        }
    }


    render() {
        const current = typeof localStorage.city !== "undefined" ? endpoints.getCurrentCity() : null;
        return (
            <Modal open={this.props.selectCity.show} onClose={this.closeModal} title="Choose your city" variant="sheet">
                <p className="v-city__intro">Availability and pricing are specific to each city.</p>
                <div className="v-city">
                    {CITIES.map((city) => (
                        <button
                            key={city.name}
                            type="button"
                            className={`v-city__option ${current === city.name ? 'is-current' : ''}`}
                            aria-current={current === city.name ? 'true' : undefined}
                            onClick={() => this.selectCity(city.name, city.id)}
                        >
                            <span className="v-city__icon"><Icon name="pin" size={20} /></span>
                            <span className="v-city__name">{city.label}</span>
                            {current === city.name
                                ? <span className="v-city__tag">Current</span>
                                : <Icon name="chevronRight" size={18} className="v-city__chev" />}
                        </button>
                    ))}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (currentState) => {
    return {
        selectCity: currentState.selectCity,
    };
};

const mapActionsToProps = (dispatch) => {
    return {
        selectCityOpen: () => {
            dispatch({ type: 'user.city.show' });
        },
        selectCityClose: () => {
            dispatch({ type: 'user.city.hide' });
        }
    };
}

export default connect(mapStateToProps, mapActionsToProps)(ServiceAreaSelect);
